import React from 'react'
import {connect} from 'react-redux'

const ConversationSecondaryHeader = (props) => {
  return (
    <div className='conversation-secondary-header'
        style={{backgroundClolor: props.backgroundColor, height: props.height}}>
      <div className='conversation-secondary-header-wrapper'>
        {props.children}
      </div>
    </div>
  )
}

ConversationSecondaryHeader.defaultProps = {
  height: 62
}

const mapStateToProps = (state) => {
  return {
    backgroundColor: state.getIn(['chatSettings', 'colors', 'conversation', 'secondaryHeaderBackground'])
  }
}

const ConversationSecondaryHeaderContainer = connect(
  mapStateToProps
)(ConversationSecondaryHeader)

export default ConversationSecondaryHeaderContainer




/** WEBPACK FOOTER **
 ** ./modules/chat_ui/conversation_secondary_header.js
 **/